import React from 'react'
import { FormControl, Typography, FormControlLabel, Checkbox, FormGroup, Box } from '@mui/material'
import type { RadioButtonGroupProps, FieldValues } from 'react-hook-form-mui'
import { InvalidQuestionError } from '../../styles'
import { useController } from 'react-hook-form'
import QuestionHeader from '../../../StudentSurveyListFeature/components/QuestionHeader'
import { grey } from '../../../../colors'

interface MultiSelectCardProps extends Omit<RadioButtonGroupProps<FieldValues>, 'options'> {
  title: string
  options: string[]
  questionNumber: number
  invalidQuestionItemId: string | undefined
  isRequired: boolean
}

const MultiSelectCard: React.FC<MultiSelectCardProps> = ({
  title,
  name,
  options,
  disabled = false,
  questionNumber,
  isRequired,
  invalidQuestionItemId,
  onChange,
  ...rest
}): JSX.Element => {
  const {
    field: { value, onChange: hookFormOnChange }
  } = useController({ name, defaultValue: [] })

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): any => {
    const targetValue = event.target.name
    const currentIndex = value.indexOf(targetValue)
    const newValue = [...value]

    if (currentIndex === -1) {
      newValue.push(targetValue)
    } else {
      newValue.splice(currentIndex, 1)
    }

    onChange?.(newValue)
    hookFormOnChange(newValue)
  }

  return (
    <Box tabIndex={0} aria-label={`Survey Question ${questionNumber} ${title}`} id={name} sx={{ p: '14px 18px', border: `1px solid ${grey[200]} `, borderRadius: '10px' }}>
      <QuestionHeader onChange={onChange} isRequired={isRequired} name={name} />
      {invalidQuestionItemId && invalidQuestionItemId === name && (<InvalidQuestionError>*Response required. Please answer and submit again.</InvalidQuestionError>)}

          <Typography variant="h5" component="h3" color={disabled ? 'text.secondary' : 'text.primary'} my={2}>
            {questionNumber}. {title}
          </Typography>

        <FormControl aria-label={title}>
          <FormGroup>
            {options.map(option => (
              <FormControlLabel
                key={option}
                control={
                  <Checkbox
                    checked={value.includes(option)}
                    onChange={handleChange}
                    name={option}
                    disabled={disabled}
                  />
                }
                label={option}
              />
            ))}
          </FormGroup>
        </FormControl>
    </Box>
  )
}

export default MultiSelectCard
